import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppSettings } from 'pac-api';
import { Observable, of } from 'rxjs';
import { map, share } from 'rxjs/operators';

import { empty } from './helpers';
import { LoggerService } from './logger.service';
import { Association } from './model/assoication';
import { TaxonomyTerm } from './model/taxonomy-term';

@Injectable({
  providedIn: 'root'
})
export class TaxonomyService {

  private cache: Map<string, TaxonomyTerm>;

  constructor(
    private http: HttpClient,
    private logger: LoggerService,
    @Inject(DOCUMENT) private doc: Document,
    private settings: AppSettings,
  ) {
    this.cache = new Map();
  }

  public GetTaxonomy(vocabulary: string): Observable<TaxonomyTerm[]> {
    const observable = this.http.get(
      '/pac-base/taxonomy/' + vocabulary,
      {
        params: {},
        withCredentials: true
      }
    );

    const shared = observable.pipe(map((result: any) => {
      if (result.error) {
        return result;
      } else if (result instanceof Array) {
        const list = Array();
        for (const item of result) {
          const term = new TaxonomyTerm(item);

          try {
            if (!empty(term.field_svg_path)) {
              const fragment = this.doc.createElement('svg');

              if (term.field_svg_path && 'und' in term.field_svg_path && term.field_svg_path.und.length > 0) {
                fragment.innerHTML = <string>term.field_svg_path.und[0].value;
              } else if (term.field_svg_path && term.field_svg_path instanceof Array && term.field_svg_path.length > 0) {
                fragment.innerHTML = <string>term.field_svg_path[0].value;
              } else {
                throw 'No SVG path found';
              }

              const path = <HTMLElement>fragment.firstChild;
              term.path = path.getAttribute('d');

              if (path.hasChildNodes() && path.children[0].nodeName === 'TEXT') {
                const text: HTMLElement = <HTMLElement>path.children[0];
                term.label = {
                  text: text.innerText,
                  x: parseFloat(text.getAttribute('x')),
                  y: parseFloat(text.getAttribute('y'))
                };
              }
            }
          } catch (e) {
            console.error(e);
          }

          list.push(term);
        }
        return list;
      }
    }), share());

    shared.subscribe(result => {
      try {
        this.logger.info(result);
      } catch {
        // IE is a big baby
      }
    });

    return shared;
  }

  public GetTaxonomyTerm(vocabulary: string, term: string, asn?: Association): Observable<TaxonomyTerm> {

    const cacheKey = (asn ? asn : this.settings.pac_base_asn_code) + '-' + vocabulary + '-' + term;

    if (this.cache.has(cacheKey)) {
      return of(this.cache.get(cacheKey));
    }

    const url = (!asn || asn === this.settings.pac_base_asn_code) ?
      '/'
      : this.settings.systemoptions['PAC.Web.' + asn];

    const observable = this.http.get(
      url + 'pac-base/taxonomy/' + vocabulary + '/' + term,
      {
        params: {},
        withCredentials: true
      }
    );

    const shared = observable.pipe(map((result: any) => {
      if (result.error) {
        return result;
      } else if (typeof (result) === 'object') {
        return new TaxonomyTerm(result);
      }
    }), share());

    shared.subscribe(result => {
      try {
        this.logger.info(result);

        this.cache.set(cacheKey, result);
      } catch {
        // IE is a big baby
      }
    });

    return shared;
  }

}
